<template>
  <div
    :class="[
      $style['dot-load'],
      theme && $style[`dot-load--${theme}`],
    ]"
  >
    <span :class="[$style.dot, $style['dot-1']]" />
    <span :class="[$style.dot, $style['dot-2']]" />
    <span :class="[$style.dot, $style['dot-3']]" />
  </div>
</template>

<script>
export default {
  name: 'LoadingDots',
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" module>
$ui-colors: (
  white: #fff,
  grey: #ccc,
);

.dot-load {
  width: 100%;
  text-align: center;

  > .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 3px;
    vertical-align: middle;
    animation-name: dot-load;
    animation-duration: 0.7s;
    animation-iteration-count: infinite;
  }

  @each $theme, $color in $ui-colors {
    &--#{$theme} {
      > .dot {
        background-color: $color;
      }
    }
  }

  @for $i from 1 through 3 {
    > .dot-#{$i} {
      animation-delay: #{$i * 0.1}s;
    }
  }
}

@keyframes dot-load {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.2;
  }

  100% {
    opacity: 1;
  }
}
</style>
